import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  height: 50%;
  position: absolute;
  display: -webkit-flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: flex-end;

  gap: 1.8rem;
  bottom: 0;
  padding-bottom: 112px;
  left: 0;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.360417) 51.56%,
    rgba(0, 0, 0, 0.4) 100%
  );
`;

function CardBody({ children, onClick, onMouseEnter }) {
  return (
    <Wrapper onMouseEnter={onMouseEnter} onClick={onClick}>
      {children}
    </Wrapper>
  );
}

export default CardBody;
